import {UserProperties} from '../utils/userProperties'

import {useBooleanUserProperty} from './useUserProperty'

export const useIsHighlightMyChangesAndInvestigations = () =>
  useBooleanUserProperty(UserProperties.HIGHLIGHT_MY_CHANGES, true)
